import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import useModal from '../../hooks/useModal';

export default function RootModal() {
  const { data: modal, close } = useModal();
  const location = useLocation();
  window.onpopstate = () => close();

  useEffect(() => {
    close();
  }, [location.pathname]);

  return (
    <Modal
      className={modal.options?.className}
      backdrop={modal.options?.backdrop || 'static'}
      size={modal.options?.size || 'md'}
      keyboard={modal.options?.keyboard || true}
      fullscreen={modal.options?.fullscreen || false}
      centered={modal.options?.centered || true}
      show={!!modal.content}
      animation={modal.options?.fade || false}
      enforceFocus={modal.options?.enforceFocus === false ? false : true}
      onHide={modal.options?.onClose || close}>
      {modal.content}
    </Modal>
  );
}
